(() => {
  if (customElements.get('ardmore-sticky-cart')) return;
  class ArdmoreStickyCart extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.root = this.closest('[id^="MainProduct-"]');
      if (!this.root) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.lastSubmit = -Infinity;
      this.bar = document.createElement('div');
      this.bar.className = 'ardmore-sticky-cart';
      this.bar.inert = true;
      this.bar.setAttribute('role', 'region');
      this.bar.setAttribute('aria-label', 'Quick add to cart');
      this.bar.innerHTML = '<div class="ardmore-sticky-cart__quantity"><button type="button" data-step="minus" aria-label="Decrease quantity">−</button><span aria-live="polite"></span><button type="button" data-step="plus" aria-label="Increase quantity">+</button></div><button type="button" class="ardmore-sticky-cart__add"></button>';
      this.spacer = document.createElement('div');
      this.spacer.setAttribute('aria-hidden', 'true');
      document.body.append(this.bar, this.spacer);
      this.add = this.bar.querySelector('.ardmore-sticky-cart__add');
      this.stepper = this.bar.querySelector('.ardmore-sticky-cart__quantity');
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
      };
      this.bar.addEventListener('click', event => {
        this.refresh();
        if (!this.visible || this.add.disabled) return;
        const step = event.target.closest('[data-step]');
        if (step) {
          this.quantity?.closest('quantity-input')?.querySelector(`button[name="${step.dataset.step}"]`)?.click();
          this.refresh();
          return;
        }
        if (!event.target.closest('.ardmore-sticky-cart__add')) return;
        if (performance.now() - this.lastSubmit < 600) return;
        this.lastSubmit = performance.now();
        this.inline.form.requestSubmit(this.inline);
        this.refresh();
      }, { signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      this.root.addEventListener('change', this.schedule, { signal });
      this.root.addEventListener('input', this.schedule, { signal });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'style', 'min', 'max', 'step', 'value'] });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.root);
      this.refresh();
    }
    refresh() {
      this.inline = this.root.querySelector('.product__info-container product-form button[name="add"]');
      this.quantity = this.root.querySelector('.product__info-container input.quantity__input');
      const button = this.inline;
      const busy = !!button && (button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true');
      this.visible = !!(window.matchMedia('(max-width: 989px)').matches && button?.form && button.getClientRects().length && button.getBoundingClientRect().bottom <= 0 && !button.disabled);
      this.bar.dataset.visible = String(this.visible);
      this.bar.inert = !this.visible;
      this.add.disabled = !this.visible || busy;
      this.add.setAttribute('aria-busy', String(busy));
      const label = busy ? 'Adding…' : (button?.querySelector('span:not(.loading__spinner):not(.sold-out-message)')?.textContent.trim() || 'Add to cart');
      if (this.add.textContent !== label) this.add.textContent = label;
      const height = this.visible ? `${this.bar.getBoundingClientRect().height}px` : '0px';
      if (this.spacer.style.height !== height) this.spacer.style.height = height;
      const quantity = this.quantity;
      this.stepper.hidden = !quantity || !!quantity.closest('.ARD-004_buy-row--hide-qty') || !quantity.getClientRects().length;
      if (!this.stepper.hidden) {
        this.stepper.querySelector('span').textContent = quantity.value;
        for (const direction of ['minus', 'plus']) {
          const original = quantity.closest('quantity-input')?.querySelector(`button[name="${direction}"]`);
          const limit = direction === 'minus' ? Number(quantity.min || 1) : Number(quantity.max);
          const atLimit = direction === 'minus' ? Number(quantity.value) <= limit : limit > 0 && Number(quantity.value) >= limit;
          this.stepper.querySelector(`[data-step="${direction}"]`).disabled = busy || !original || original.disabled || original.classList.contains('disabled') || atLimit;
        }
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.bar?.remove();
      this.spacer?.remove();
      this.controller = null;
    }
  }
  customElements.define('ardmore-sticky-cart', ArdmoreStickyCart);
})();
